import { Button } from '@artic/ui/button';
import { useTranslation } from 'react-i18next';

import type { ProjectPlanningListItem } from './types';

interface ProjectListRowActionsProps {
  project: ProjectPlanningListItem;
  onEdit: (project: ProjectPlanningListItem) => void;
}

/**
 * Per-row actions on the Project Index (ENG-819): an Edit action opening the
 * shared EditProjectDialog for the row's project. Editing follows the same
 * gate as the project page's "Update Project" button — draft or redrafting
 * only (a stored status; released work must be redrafted first) — with the
 * shared i18n key as the disabled tooltip so the gate copy stays
 * single-sourced. The dialog itself is hosted once by the page, not per row.
 */
export function ProjectListRowActions({ project, onEdit }: ProjectListRowActionsProps) {
  const { t } = useTranslation('project');
  const canEdit = project.project_status === 'draft' || project.project_status === 'redrafting';

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => onEdit(project)}
      disabled={!canEdit}
      title={canEdit ? undefined : t('header.updateProjectDisabled')}
    >
      Edit
    </Button>
  );
}
